import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function SearchNotFound(t0) {
  const $ = _c(45);
  let other;
  let query;
  let slotProps;
  let sx;
  if ($[0] !== t0) {
    ({
      query,
      sx,
      slotProps,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = query;
    $[3] = slotProps;
    $[4] = sx;
  } else {
    other = $[1];
    query = $[2];
    slotProps = $[3];
    sx = $[4];
  }
  const {
    t
  } = useTranslate();
  if (!query) {
    const t1 = slotProps?.description;
    let t2;
    if ($[5] !== t) {
      t2 = t("Please enter keywords");
      $[5] = t;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
      t3 = <Typography variant="body2" {...t1}>{t2}</Typography>;
      $[7] = t1;
      $[8] = t2;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  let t1;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      p: 2,
      gap: 1,
      display: "flex",
      borderRadius: 1.5,
      textAlign: "center",
      flexDirection: "column"
    };
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== sx) {
    t2 = Array.isArray(sx) ? sx : [sx];
    $[11] = sx;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== t2) {
    t3 = [t1, ...t2];
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const t4 = slotProps?.title;
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "text.primary"
    };
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== slotProps?.title?.sx) {
    t6 = Array.isArray(slotProps?.title?.sx) ? slotProps?.title?.sx ?? [] : [slotProps?.title?.sx];
    $[16] = slotProps?.title?.sx;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t6) {
    t7 = [t5, ...t6];
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t) {
    t8 = t("No results");
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t4 || $[23] !== t7 || $[24] !== t8) {
    t9 = <Typography variant="h6" {...t4} sx={t7}>{t8}</Typography>;
    $[22] = t4;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const t10 = slotProps?.description;
  let t11;
  if ($[26] !== t) {
    t11 = t("No results found for");
    $[26] = t;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <br />;
    t13 = {
      overflowWrap: "anywhere"
    };
    $[28] = t12;
    $[29] = t13;
  } else {
    t12 = $[28];
    t13 = $[29];
  }
  const t14 = `"${query}"`;
  let t15;
  if ($[30] !== t14) {
    t15 = <strong style={t13}>{t14}</strong>;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <br />;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t) {
    t17 = t("Try checking for typos or using complete words");
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t15 || $[38] !== t17) {
    t18 = <Typography variant="body2" {...t10}>{t11}{t12}{t15}{t16}{t17}.</Typography>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t15;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== other || $[41] !== t18 || $[42] !== t3 || $[43] !== t9) {
    t19 = <Box sx={t3} {...other}>{t9}{t18}</Box>;
    $[40] = other;
    $[41] = t18;
    $[42] = t3;
    $[43] = t9;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
}